import React from 'react'
import UserList from '../components/User/UserList'


const UserScreen = () => {

  return (
    <div>
        <UserList/>
    </div>
  )
}

export default UserScreen